<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <h4 v-if="!propOpenedInModal" class="card-title">{{ cvCardTitle }}</h4>
          <ValidationObserver ref="SpcmCalendarCategory">
            <form action="#">
              <div class="form-row">
                <div class="col-md-12 mb-3">
                  <label for="validationcategory_name">{{cvCategoryNameLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="CategoryName" rules="required|min:3|max:20" v-slot="{ errors }">
                    <input
                      v-model="vmSpcmCalendarCategoryFormData.category_name"
                      placeholder="Enter CategoryName"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <span class=""><small><i>* Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</i></small></span>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationdescription">{{cvDescriptionLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="Description" rules="required|min:3|max:20" v-slot="{ errors }">
                    <input
                      v-model="vmSpcmCalendarCategoryFormData.description"
                      placeholder="Enter Description"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <span class=""><small><i>* Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</i></small></span>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationcolor_code">{{cvColorCodeLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="ColorCode" rules="required|min:3|max:20" v-slot="{ errors }">
                    <input
                      v-model="vmSpcmCalendarCategoryFormData.color_code"
                      placeholder="Enter ColorCode"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <span class=""><small><i>* Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</i></small></span>
                </div>
                <div class="col-md-12 mb-3">
                  <label for="validationspcm_session_allow">{{cvSpcmSessionAllowLabel}}</label> <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="SpcmSessionAllow" rules="required|min:3|max:20" v-slot="{ errors }">
                    <input
                      v-model="vmSpcmCalendarCategoryFormData.spcm_session_allow"
                      placeholder="Enter SpcmSessionAllow"
                      type="text"
                      class="form-control"
                      required
                    />
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <span class=""><small><i>* Lorem ipsum is a dummy or placeholder text commonly used in graphic design, publishing, and web development.</i></small></span>
                </div>

              </div>
              <div class="form-group">
                <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" :disabled="cvLoadingStatus">
                  <b-spinner label="Spinning"></b-spinner>
                </button>
                <button type="button" class="btn btn-primary" @click="SpcmCalendarCategoryAdd()" > {{ cvSubmitBtn }} </button>
              </div>
            </form>
          </ValidationObserver>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { SpcmCalendarCategorys } from "../../../FackApi/api/SpcmCalendarCategory.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "SpcmCalendarCategoryAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cvCardTitle: "Add SpcmCalendarCategory",
      cvSubmitBtn: "Add",
      cvCategoryNameLabel: "category name",
      cvDescriptionLabel: "description",
      cvColorCodeLabel: "color code",
      cvSpcmSessionAllowLabel: "spcm session allow",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "SpcmCalendarCategory Added",
      vmSpcmCalendarCategoryFormData: Object.assign({}, this.initFormData()),
      vmSpcmCalendarCategoryDesc: null,
      vmSpcmCalendarCategoryType: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "category_name": "",
        "description": "",
        "color_code": "",
        "spcm_session_allow": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmSpcmCalendarCategoryFormData) {
          if (!this.vmSpcmCalendarCategoryFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * SpcmCalendarCategoryAdd
     */
    async SpcmCalendarCategoryAdd () {
      try {
        this.cvLoadingStatus = true
        let SpcmCalendarCategoryAddResp = await SpcmCalendarCategorys.SpcmCalendarCategoryAdd(this, this.vmSpcmCalendarCategoryFormData)
        await ApiResponse.responseMessageDisplay(this, SpcmCalendarCategoryAddResp)
        if (SpcmCalendarCategoryAddResp && !SpcmCalendarCategoryAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseSpcmCalendarCategoryAddModal", SpcmCalendarCategoryAddResp.resp_data)
        }
        this.vmSpcmCalendarCategoryFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at SpcmCalendarCategoryAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
